import { ROOT_CATEGORY_ID } from "../../../normalizers/constants";
import { normalizeUserQuantity } from "../../../normalizers/normalizeUserQuantity";

export function handleUserQuantityDefinitionCreated(state, payload) {
    // The payload contains the category wrapper with the quantity inside
    // console.log('handleUserQuantityDefinitionCreated payload: ', payload)
    const { quantity_definition: quantity, category: cat } = payload;
    // console.log('handleUserQuantityDefinitionCreated quantity: ', quantity)
        // console.log('handleUserQuantityDefinitionCreated cat: ', cat)
    // 1. Normalize the new quantity
    const normalized = normalizeUserQuantity(quantity);
    
    // 2. Skip if quantity already exists
    if (state.quantitiesById[normalized.nodeId]) {
        console.warn('Quantity already exists:', normalized.nodeId);
        return state;
    }
    
    // 3. Update quantitiesById
    const updatedQuantitiesById = {
        ...state.quantitiesById,
        [normalized.nodeId]: normalized,
    };
    
    // 4. Determine category ID (use root if no category)
    const targetCategoryId = cat.id == null ? ROOT_CATEGORY_ID : cat.id;
    const isRootCategory = targetCategoryId === ROOT_CATEGORY_ID;
    
    // 5. Update categoriesById and categoryIds
    let updatedCategoriesById = { ...state.categoriesById };
    let updatedCategoryIds = [...state.categoryIds];
    
    // Check if category exists
    if (!updatedCategoriesById[targetCategoryId]) {
        // Create new category matching normalizeUserSnapshot structure
        updatedCategoriesById[targetCategoryId] = {
            id: isRootCategory ? null : cat.id,
            nodeId: isRootCategory ? ROOT_CATEGORY_ID : `c${cat.id}`,
            code: isRootCategory ? null : (cat.code || null),
            title: isRootCategory ? "Root" : (cat.title || "Uncategorized"),
            type: "category",
            orderNumber: isRootCategory ? 0 : (cat.order_number ?? 9999),
            quantities: [],
        };
        
        updatedCategoryIds.push(targetCategoryId);
        
        // Sort categoryIds (root should be first)
        updatedCategoryIds.sort((a, b) => {
            if (a === ROOT_CATEGORY_ID) return -1;
            if (b === ROOT_CATEGORY_ID) return 1;
            const orderA = updatedCategoriesById[a].orderNumber ?? 9999;
            const orderB = updatedCategoriesById[b].orderNumber ?? 9999;
            return orderA - orderB;
        });
    }
    
    // 6. Add the new quantity to the category's quantities array
    const category = updatedCategoriesById[targetCategoryId];
    const quantityExists = category.quantities.some(q => q.id === normalized.id);
    
    if (!quantityExists) {
        updatedCategoriesById[targetCategoryId] = {
            ...category,
            quantities: [...category.quantities, normalized],
        };
    } else {
        // Update existing quantity if needed
        const updatedQuantities = category.quantities.map(q => 
            q.id === normalized.id ? { ...q, ...normalized } : q
        );
        
        updatedCategoriesById[targetCategoryId] = {
            ...category,
            quantities: updatedQuantities,
        };
    }
    
    console.log('Updated state:', {
        newQuantityId: normalized.nodeId,
        targetCategory: targetCategoryId,
        totalCategories: Object.keys(updatedCategoriesById).length,
        totalQuantities: Object.keys(updatedQuantitiesById).length,
    });
    
    // 7. Return updated state
    return {
        ...state,
        quantitiesById: updatedQuantitiesById,
        categoriesById: updatedCategoriesById,
        categoryIds: updatedCategoryIds,
    };
}